import { Component, OnInit, ElementRef, ViewChild, Inject  } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {NavigatorService} from '../../services/navigatorService/navigator.service';
import {UserService} from '../../services/api-handlers/userService/user.service';
import {BootstrapNotifyService} from '../../services/bootstrap-notify/bootstrap-notify.service';
import {CacheService} from '../../services/cacheService/cache.service';
import {SharedFormService} from "../../services/shared-form.service";
import {IResponse} from "../../interfaces/iresponse";
import {environment as ENV} from "../../../environments/environment";
declare const $: any;

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit {
  /*public signup = {
    EmailAddress: '',
    KycDocument: ''
  };
  loaders = {
    loading: false
  };
  public loading = false;*/

  constructor(private navigatorService: NavigatorService,@Inject(DOCUMENT) document) {
    let seconds: number;
    seconds = 30; // seconds for HTML
    let foo; // variable for clearInterval() function

    setTimeout(() => {
      this.navigatorService.navigateUrl('/verify-account');
    }, 30000);  //30s

    function updateSecs() {
      document.getElementById("seconds").innerHTML = seconds;
      seconds--;
      if (seconds == -1) {
        clearInterval(foo);
        setTimeout;
      }
    }

    function countdownTimer() {
      foo = setInterval(function () {
        updateSecs()
      }, 1000);
    }

    countdownTimer();
  }
  /*constructor(private userService: UserService, private navigatorService: NavigatorService,
              private cacheService: CacheService,
              private bootstrapService: BootstrapNotifyService, private sharedFormService: SharedFormService, private navigationService: NavigatorService) {
  }*/

  ngOnInit(): void {

    // console.log('SignUp2 Page Message', this.sharedFormService.admissionData);
  }

  /*public processSignUp() {
    if (!this.signup.EmailAddress || !this.signup.KycDocument) {
      return this.bootstrapService.error('Ensure EmailAddress and KycDocument Input Fields are Filled!!!');
    } else {
      this.loaders.loading = true;
      this.sharedFormService.signupData = this.signup;
      console.log('Data from SignUP3 Page', this.signup);

      this.userService.signUp(this.signup).subscribe((res: any) => {
        console.log('Signup Full Data', this.signup);
        this.loading = false;
        this.bootstrapService.success('Sign Up Process successful!!');
        this.navigatorService.navigateUrl('/client/dashboard');
      }, error => {
        this.loading = false;
        console.info('Error with form ', error);
        this.bootstrapService.error(error.error.message|| 'Unable to continue process');
        // this.bootstrapService.error(error.error.description, error.error.code);
      });
    }
  }*/

}
